import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";

import { useTheme } from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";
import CardContent from "@mui/material/CardContent";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Popper from "@mui/material/Popper";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import Avatar from "../../../../../components/@extended/Avatar";
import Transitions from "../../../../../components/@extended/Transitions";
import MainCard from "../../../../../components/MainCard";

import LogoutOutlined from "@ant-design/icons/LogoutOutlined";
import userdefault from "../../../../../../assets/images/userdefault.png";
import {
  auth,
  getRootURL,
  getTokenType,
  imgBaseURL,
} from "../../../../../../helper/Utility";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { useGetUserDataQuery } from "../../../../../../features/common/CommonAPI";
import { Skeleton } from "@mui/material";
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

export default function Profile() {
  const { data: authStoreData } = useGetUserDataQuery();
  const authUser = auth("admin");
  const theme = useTheme();
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleLogout = (type) => {
    localStorage.removeItem(getTokenType(type));
    navigate("/login");
  };

  const displayDetails = {
    fullname:
      authStoreData?.data?.firstName + " " + authStoreData?.data?.lastName,
    business_name: authStoreData?.data?.businessName,
    role: authStoreData?.data?.role,
    avatar: authStoreData?.data?.avatar,
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <ButtonBase
        sx={{
          p: 0.25,
          borderRadius: 1,
        }}
        aria-label="open profile"
        ref={anchorRef}
        aria-controls={open ? "profile-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <Stack spacing={1.25} alignItems="center">
          <div className="bage_profile d-flex gap-2 align-items-center">
            <Avatar
              alt="profile user"
              src={
                displayDetails?.avatar
                  ? imgBaseURL() + displayDetails.avatar
                  : userdefault
              }
              size="sm"
              className="my_logo"
              sx={{
                width: 40,
                height: 40,
                objectFit: "cover",
              }}
            />
            <div className="profile_deat">
              <div className="text-start">
                <p className="m-0 admin_tile"> Admin</p>
              </div>
              <div>
                <span className="text-capitalize admin_tile_role">
                  {
                displayDetails?.fullname}
                </span>
              </div>
            </div>
          </div>
        </Stack>
      </ButtonBase>
      <div className="d-flex">
        <Popper
          placement="bottom-end"
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          popperOptions={{
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 9],
                },
              },
            ],
          }}
        >
          {({ TransitionProps }) => (
            <Transitions
              type="grow"
              position="top-right"
              in={open}
              {...TransitionProps}
            >
              <Paper
                sx={{
                  boxShadow: theme.customShadows.z1,
                  width: 290,
                  minWidth: 240,
                  maxWidth: { xs: 250, md: 290 },
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <MainCard
                    className="outer_profile"
                    elevation={0}
                    border={false}
                    content={false}
                  >
                    <CardContent sx={{ px: 2.5, pt: 3 }}>
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid item>
                          <Stack
                            direction="row"
                            spacing={1.25}
                            alignItems="center"
                          >
                            <Avatar
                              alt="profile user"
                              src={
                                displayDetails?.avatar
                                  ? imgBaseURL() + displayDetails.avatar
                                  : userdefault
                              }
                              className="my_logo align-items-center"
                              sx={{ width: 38, height: 38 }}
                            />
                            <Stack>
                              <p className="user_profile_name m-0">
                                Admin
                              </p>
                            
                            </Stack>
                          </Stack>
                        </Grid>

                        <Grid item>
                          <Tooltip title="Logout">
                            <IconButton
                              size="large"
                              sx={{ color: "text.primary" }}
                              onClick={() => handleLogout("admin")}
                            >
                              <LogoutOutlined />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </Grid>

                      <Grid item className="mt-3">
                        <Stack
                          direction="row"
                          spacing={1.25}
                          alignItems="center"
                        >
                          <PersonIcon />
                          <Stack>
                            <Link
                              className="d-block"
                              to={`/${getRootURL()}/profile`}
                              onClick={handleClose}
                            >
                              {" "}
                              Profile{" "}
                            </Link>
                          </Stack>
                        </Stack>
                      </Grid>

                      {/* <Grid item className="mt-3">
                        <Stack
                          direction="row"
                          spacing={1.25}
                          alignItems="center"
                        >
                          <SecurityIcon />

                          <Stack>
                            <Link
                              to={`/${getRootURL()}/change-password`}
                              onClick={handleClose}
                            >
                              {" "}
                              Change Password{" "}
                            </Link>
                          </Stack>
                        </Stack>
                      </Grid> */}

                      {(authUser?.user_role === "shop_owner" ||
                        authUser?.user_role === "advertiser") && (
                        <Grid item className="mt-3">
                          <Stack
                            direction="row"
                            spacing={1.25}
                            alignItems="center"
                          >
                            <SubscriptionsIcon />
                            <Stack>
                              <Link
                                to={`/${getRootURL()}/current-plan`}
                                onClick={handleClose}
                              >
                                Current Plan{" "}
                              </Link>
                            </Stack>
                          </Stack>
                        </Grid>
                      )}
                    </CardContent>
                  </MainCard>
                </ClickAwayListener>
              </Paper>
            </Transitions>
          )}
        </Popper>
      </div>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number,
  index: PropTypes.number,
  other: PropTypes.any,
};
